import { NgClass } from '@angular/common';
import { Component, Input } from '@angular/core';

@Component({
  selector: 'app-new-modal-body',
  imports: [NgClass],
  templateUrl: './new-modal-body.component.html',
  styleUrl: './new-modal-body.component.scss'
})
export class NewModalBodyComponent {
  @Input() size: 'small' | 'medium' | 'large' = 'small';

  /** When true, the shell does not scroll; let projected content own internal scroll regions (e.g. tables). */
  @Input() containInnerScroll = false;
}
